import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParseDefault } from '../Parsers/TEDParserDefault';
import { TEDDisplayMinutes } from '../Displayers/TEDDisplayMinutes';

class TEDFormatMinutes implements IFormatter {
  displayer = TEDDisplayMinutes.getInstance();
  parser = TEDParseDefault.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatMinutes };
